<rap-users-ui
  [users]="users$ | async"
  [usersCount]="usersCount$ | async"
  (getUsersEmitter)="getUsers($event)"
  (deleteUserEmitter)="deleteUser($event)"
  (approveUserEmitter)="approveUser($event)"
  (editUserEmitter)="editUser($event)"
  (performActionEmitter)="performAction($event)"
></rap-users-ui>
